module.exports = __webpack_public_path__ + "img/team3.d68c0425.png";